<style lang="stylus" scoped>
.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}
</style>
<template>
<div>
  <div class="mark" v-if="mark">
      <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
    </div>
  <el-dialog :visible.sync="mouthShow" title="请选择您需要导出数据的季度" class="el-allData" @close="hideExport">
      <el-row class="el-year">
        <el-col :span="1" @click.native="preYear"><i class="el-icon-arrow-left"></i></el-col>
        <el-col :span="22" class="export-title">{{selecedYear}}</el-col>
        <el-col :span="1" @click.native="nextYear"><i class="el-icon-arrow-right"></i></el-col>
      </el-row>
     <el-row class="el-btn-m">
       <el-checkbox-group v-model="checkList">
        <el-col :span="12"  v-for="item in mouthData" :key="item.key"><el-checkbox :label="item.key"   :disabled="item.isDisabled"   @change="changeCheck(item)">{{item.name}}</el-checkbox></el-col>
      </el-checkbox-group>
      </el-row>
      <el-row class="more-export">
        <el-col :span="12"><el-button @click="hideExport">取消</el-button></el-col>
        <el-col :span="12"><el-button type="primary" @click="confirmExport">确认导出</el-button></el-col>
      </el-row>
    </el-dialog>
</div>
</template>
<script>
import https from '@/api/freight.js'
import http from '@/api/cardData'
import Cookies from 'js-cookie'
var now = new Date()
now.setMonth(now.getMonth() - 1)
export default {
  props: {
    moduleName:{
      type:String
    },
    provCode:{
      type:String
    },
    city:{
      type:String
    },
    range:{
      type:String
    },
    provName:{
      type:String
    },
    companyName:{
      type:String
    },
    defaultTab:{
      type:String
    }
  },
  data() {
    return {
      checkList: [],
       progressNum: 0, //进度条进度
      mark: false ,//是否显示遮罩层
      mouthShow:true,
      monTime: now,
      mouthData:[],
      mouthAll:["1季度","2季度","3季度","4季度"],
      selecedYear:'',
      numerdata:[{mouth:["01","02","03"]},{mouth:["04","05","06"]},{mouth:["07","08","09"]},{mouth:["10","11","12"]}],
      tempChooseArr:[],
    }
  },
  mounted() {
  },
  created(){
    this.mouthShow = true
    this.showAddTow = true
    this.getendMonth()
  },
  beforeDestroy() {
  },
  computed: {
    allTab: function() {
      return this.$store.state.app.tab
    },
  },
  methods: {
     getendMonth(){
      let that = this
      let time = that.monTime
      let year = time.getFullYear()
      this.selecedYear=year
      this.initMonthData()
    },
    hideExport(){
      this.$emit('hideExport')
    },
     //导出
    confirmExport() {
      let that = this
      let tempChooseArr = this.tempChooseArr
      if(tempChooseArr.length==0){
        this.$message({
          message: '至少要选择一个月份!',
          type: 'warning'
        });
        return
      }
      this.mouthShow=false
      that.mark = true
      let reqId = Cookies.get('user')
      let moduleName=this.moduleName
      var yearMonths=''
      var numerdata=this.numerdata
       for(var v of tempChooseArr){
        let mouthArr=v.mouthArr
        for(var val of mouthArr){
          let index=parseInt(val)-1
          let jdData=numerdata[index].mouth
          yearMonths+=v.yearName+jdData[0]+"-"+v.yearName+jdData[2]+","
        }
      }
     
      yearMonths = yearMonths.substring(0, yearMonths.lastIndexOf(','));
      window.times = setInterval(function() {
        http[that.allTab].progress({ reqId }).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            that.mark = false
            that.$emit('hideExport')
            that.progressNum = 0
            clearInterval(window.times)
          }
        })
      }, 100)
      // return
      reqId += new Date() * 1
      //  企业
       if(moduleName=="companyDetail"){
         let provCode=that.provCode
         let cityCode=that.city
         let order=that.defaultTab
         let percentage=that.range
        window.location.assign(
          https
          .exportCompanyExport({
            yearMonths: yearMonths,
            reqId,
            provCode,
            cityCode,
            order,
            percentage
          })
        )
       }
      // 企业汽车
      if(moduleName=="companyVehicleDetail"){
        let provName=that.provName
        let companyName=that.companyName
        window.location.assign(
          https
          .exportCompanyVehicle({
            yearMonths: yearMonths,
            reqId,
            provName,
            companyName
          })
        )
      }
    },
    initMonthData(){
      this.checkList=[]
      this.mouthData=[]
      let selecedYear=this.selecedYear
        https
        .getSeasonData({
          year: selecedYear,
          moduleName:this.moduleName
        })
        .then(e => {
          let data=e.data
          let str="ok"
          var mouthData=[]
          let mouthAll=this.mouthAll
          for(var i=0;i<data.length;i++){
            if(i<4){
                if(data[i].indexOf(str) != -1 ){
                mouthData.push({name:mouthAll[i],isDisabled:false,key:data[i].slice(0, -2),isClick:false})
                }else{
                mouthData.push({name:mouthAll[i],isDisabled:true,key:data[i],isClick:true})
                }
            }
          }
          this.mouthData=mouthData
          this.isCheckMore()
          let tempChooseArr=this.tempChooseArr
          let selecedYear=this.selecedYear
          for(var v of tempChooseArr){
            if(v.yearName==selecedYear){
              this.checkList=v.mouthArr
            }
          }
        })
    },
    changeCheck(e){
      let selecedYear=this.selecedYear
      let checkList=this.checkList
      let tempChooseArr=this.tempChooseArr
      if(tempChooseArr.length>0){
        var isPush=true
        for(var v of tempChooseArr){
          if(v.yearName==selecedYear){
            isPush=false
            v.mouthArr=checkList
          }
        }
        if(isPush){
          tempChooseArr.push({yearName:selecedYear,mouthArr:checkList})
        }
      }else{
        if(checkList.length>0){
          tempChooseArr.push({yearName:selecedYear,mouthArr:checkList})
        }
      }
      this.tempChooseArr=tempChooseArr
      this.isCheckMore()
    },
    // 判断是否超过12个月
    isCheckMore(){
      let mouthData=this.mouthData
        let tempChooseArr=this.tempChooseArr
        let selecedYear=this.selecedYear
       var lens=0
      if(tempChooseArr.length>0){
        for(var v of tempChooseArr){
          lens+=v.mouthArr.length
        }
      }
      if(lens>=4){
        // this.$message({
        //   message: '一次最多导出十二个月',
        //   type: 'warning'
        // });
        for(var v of mouthData){
          for(var k of tempChooseArr){
            if(k.yearName==selecedYear){
              let mouthArr=k.mouthArr
              if(mouthArr.indexOf(v.key)!=-1){
                v.isDisabled=false
              }else{
                v.isDisabled=true
              }
            }
          }
        }
      }else{
        let mouthData=this.mouthData
        for(var v of mouthData){
          if(v.isClick){
            v.isDisabled=true
          }else{
            v.isDisabled=false
          }
        }
      }
    },
    // 上一年下一年
    preYear(){
      let selecedYear=this.selecedYear
      if(selecedYear>0){
        this.selecedYear=selecedYear-1
        this.initMonthData()
      }
    },
    nextYear(){
      let selecedYear=this.selecedYear
      this.selecedYear=selecedYear+1
      this.initMonthData()
    },
  }
}
</script>
